import React from 'react'
import {useTranslation} from 'react-i18next'
import {disableDatesBeforeOneYear} from '@/stores'
import {RangePickerContainer, RefreshButton, SelectWithTitle} from '@/components'
import {PayByLinkFilterButton} from '@/pages/PayByLink'
import {isOctoberRestrictionEnabled} from '@/constants/dateRangePresets'
import {disabledDatesBeforeOctober2025} from '@/utils/moment-utils'
import {TableFilterProps} from './props'
import styles from './styles.scss'

export const TableFilter: React.FC<TableFilterProps> = ({
    extra,
    rangePickerInjectableIdentifier,
    defaultSelectValue,
    selectProps,
    onReloadClick
}) => {
    const {t} = useTranslation()

    const combinedDisabledDate = (date) => {
        if (isOctoberRestrictionEnabled && disabledDatesBeforeOctober2025(date)) {
            return true
        }

        return disableDatesBeforeOneYear(date)
    }

    return (
        <div className={styles.root}>
            <RefreshButton onClick={onReloadClick} />
            <PayByLinkFilterButton />
            <SelectWithTitle
                isMobile={false}
                displayValue={t('TableFilter.status')}
                defaultValue={defaultSelectValue}
                className={styles.selectWrapper}
                value={selectProps.value}
                onChange={selectProps.onChange}
                options={selectProps.options}
                placeholder={selectProps.placeholder}
            />
            <div className={styles.divider}></div>
            <RangePickerContainer
                showRangePickerTime
                disabledDate={combinedDisabledDate}
                injectableIdentifier={rangePickerInjectableIdentifier}
            />
            {extra}
        </div>
    )
}
